export default function Logo({ compact = false, light = true }) {
  return (
    <span className="inline-flex items-center gap-2.5" dir="rtl">
      <svg width="42" height="42" viewBox="0 0 64 64" fill="none" aria-hidden="true" className="shrink-0">
        <rect width="64" height="64" rx="16" fill={light ? "#111722" : "#080B10"} stroke="rgba(255,196,0,0.35)" />
        <polygon
          points="32,6 34.47,13.1 42,13.2 36,17.8 38.1,25 32,20.6 25.9,25 28,17.8 22,13.2 29.53,13.1"
          fill="#FFC400"
        />
        <path d="M15 54 L15 30 L32 44 L49 30 L49 54" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="text-2xl font-extrabold tracking-tight text-white">ميرو</span>
        {!compact && <span className="mt-1 text-[10px] font-semibold text-mist">للاطارات وخدمات السيارات</span>}
      </span>
    </span>
  );
}
